export const VERIFY_GOLD_CARD_ADDRESS = "VERIFY_GOLD_CARD_ADDRESS"



// WEBPACK FOOTER //
// ./src/constants/returnAction.js